export default __webpack_public_path__ + "static/mariam tan-71cf0a852834c22b9a4cf645bde72aab.png";